import { AddIcon } from '@systemeio/ui/icons'
import { PrimaryButton } from '@systemeio/ui'
import { BadRequest } from '@systemeio/util'
import { PipelineUpdateBody } from 'modules/crm/components/pipeline-update-body'
import { defaultErrors } from 'modules/crm/constants/default-errors'
import { defaultValues } from 'modules/crm/constants/default-values'
import { useCreatePipeline } from 'modules/crm/hooks/use-create-pipeline'
import { PipelineErrorsInterface } from 'modules/crm/pipeline/type/pipeline-errors-interface'
import { PipelineEditInterface } from 'modules/crm/types/pipeline-interface'
import React, { useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface CrmPipelineInterfaceProps {
  onUpdateData(): Promise<void>
}

export const ModalCreatePipeline = ({ onUpdateData }: CrmPipelineInterfaceProps) => {
  const { t } = useLocoTranslation()
  const [isOpened, setIsOpened] = useState<boolean>(false)

  const [tempState, setTempState] = useState<PipelineEditInterface>(defaultValues(t))
  const [errors, setErrors] = useState<PipelineErrorsInterface>(defaultErrors)

  const { createPipeline, isFetching } = useCreatePipeline()

  const onCreatePipeline = async () => {
    try {
      setErrors(defaultErrors)
      const newData = {
        name: tempState.name,
        stages: tempState.stages.map(item => ({ name: item.name })),
      }

      await createPipeline(newData)
      await onUpdateData()
      setIsOpened(false)
    } catch (error) {
      if (error instanceof BadRequest) {
        const pipelineErrors = error.errors
        if (pipelineErrors.fields) {
          setErrors(prev => {
            return {
              ...prev,
              fields: pipelineErrors.fields,
            }
          })
        }
        if (pipelineErrors.common) {
          setErrors(prev => {
            return {
              ...prev,
              common: pipelineErrors.common,
            }
          })
        }
      }
    }
  }

  const afterLeave = () => {
    setErrors(defaultErrors)
    setTempState(defaultValues(t))
  }

  return (
    <>
      <PrimaryButton isFetching={isFetching} onClick={() => setIsOpened(true)}>
        <AddIcon />
        <span> {t('global.create')}</span>
      </PrimaryButton>
      {tempState !== undefined && (
        <PipelineUpdateBody
          setTempState={setTempState}
          withConfirmation
          tempState={tempState}
          errors={errors}
          isUpdate={isFetching}
          afterLeave={afterLeave}
          onClose={() => setIsOpened(false)}
          isOpened={isOpened}
          saveCrmPipeline={onCreatePipeline}
          modalTitle={t('dashboard.crm_pipeline.modal_create.title')}
        />
      )}
    </>
  )
}
